// import { useEffect, useState } from 'react';
// import { translation } from '../util/translation';
// const { useSelector } = require('react-redux');

// const translateText = async (text, targetLang) => {
//   if (!text || !targetLang) return text;

//   const key = `${targetLang}:${text}`;
//   const cached = sessionStorage.getItem(key);
//   if (cached) {
//     return cached;
//   }
//   const translated = await translation(text, targetLang);
//   sessionStorage.setItem(key, translated);
//   return translated;
// };

// export function useTranslate(dynamicTextReference) {
//   if (typeof dynamicTextReference !== 'object' || dynamicTextReference === null) {
//     return {};
//   }
//   const [state, setState] = useState({
//     translation: dynamicTextReference,
//     isTranslating: false,
//     translateError: null,
//   });
//   const nativeLang = useSelector(state => state.ui.userNativeLang);

//   const translateAll = () => {
//     setState(prevState => ({ ...prevState, isTranslating: true, translateError: null }));
//     Promise.allSettled(
//       Object.entries(dynamicTextReference).map(async ([key, value]) => {
//         if (typeof value !== 'string') return;
//         try {
//           const translatedValue = await translateText(value, nativeLang);
//           setState(prevState => {
//             prevState.translation[key] = translatedValue;
//             return { ...prevState };
//           });
//         } catch (err) {
//           console.error('Translation error:', err);
//         }
//       })
//     )
//       .then(() => {
//         setState(prevState => ({ ...prevState, isTranslating: false }));
//       })
//       .catch(error => {
//         setState(prevState => ({ ...prevState, isTranslating: false, translateError: error }));

//         console.error('Translation error:', error);
//       });
//   };

//   useEffect(translateAll, [nativeLang]);

//   return state;
// }

// import { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { initiateTranslation, translateKeys } from '../ducks/translate.duck';

// export const useTranslate = (keysObj, pageId) => {
//   const dispatch = useDispatch();
//   const nativeLang = useSelector(state => state.ui.userNativeLang);
//   const { translations, isTranslating } = useSelector(state => state.translation);
//   const savedTranslations = translations?.[nativeLang]?.[pageId] || keysObj || {};

//   useEffect(() => {
//     if (keysObj && nativeLang) {
//       dispatch(translateKeys(keysObj, nativeLang, pageId));
//     }
//   }, [nativeLang]);

//   return { translation: savedTranslations, isTranslating };
// };

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translateKeys as translateKeysThunk } from '../ducks/translate.duck';

export const useTranslate = (keysObj, pageId, lastFetch, ...externalDeps) => {
  const dispatch = useDispatch();
  const nativeLang = useSelector(state => state.ui.userNativeLang);
  const { translations, isTranslating } = useSelector(state => state.translation);
  const savedTranslations = translations?.[nativeLang]?.[pageId] || keysObj || {};

  useEffect(() => {
    if (keysObj && nativeLang) {
      dispatch(translateKeysThunk(keysObj, nativeLang, pageId, lastFetch));
    }
  }, [nativeLang, lastFetch, ...externalDeps]);

  return { translation: savedTranslations, isTranslating };
};
